import request from '@/utils/edu_request'
// 封装接口数据
export function pintuanList(params) {
  return request({
    url: '/groupon/Details',
    method: 'GET',
    params
  })
}

export function chengjilist(params) {
  return request({
    url: '/exam/exam/getExamScore',
    method: 'GET',
    params
  })
}
export function test_list(params) {
  return request({
    url: '/exam/exam/getExamList',
    method: 'GET',
    params
  })
}
export function commits_bm(params) {
  return request({
    url: '/exam/exam/saveRegister',
    method: 'GET',
    params
  })
}
export function getInfo(params) {
  return request({
    url: '/exam/exam/getRegisterInfo',
    method: 'GET',
    params
  })
}
export function getwhcd(params) {
  return request({
    url: '/exam/exam/getEducation',
    method: 'GET',
    params
  })
}
export function get_sheng(params) { // 省
  return request({
    url: '/exam/exam/getDistrict',
    method: 'get',
    params
  })
}
export function get_Nation(params) { // 民族
  return request({
    url: '/exam/exam/getNationList',
    method: 'get',
    params
  })
}
export function get_reg(params) { // 验证码
  return request({
    url: '/exam/exam/sendCode',
    method: 'get',
    params
  })
}
export function getFormSetting(params) { // 表单信息
  return request({
    url: 'exam/exam/getFormSetting',
    method: 'get',
    params
  })
}
export function getCenter(params) { // 获取考场
  return request({
    url: 'exam/exam/getCenter',
    method: 'get',
    params
  })
}
export function getDuctmenttype(params) { // 获取证件类型
  return request({
    url: 'exam/exam/getDuctmenttype',
    method: 'get',
    params
  })
}
// 报考上传图片检测
export function getExamImgIs(params) {
  return request({
    url: '/exam/exam/getExamImgIs',
    method: 'get',
    params
  })
}